import { render, staticRenderFns } from "./addSubDistrict.vue?vue&type=template&id=43ecdabf&"
import script from "./addSubDistrict.vue?vue&type=script&lang=js&"
export * from "./addSubDistrict.vue?vue&type=script&lang=js&"
import style0 from "./addSubDistrict.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports